/* @flow weak */

'use strict';

const React = require('react');

const QuestionStore = require('../../stores/QuestionStore.jsx');

const QuestionGroupRenderer = require('../renderers/QuestionGroupRenderer.jsx');

const QuestionSection = React.createClass({
  getInitialState() {
    return {
      questions: QuestionStore.getRootQuestions()
    };
  },

  render() {
    return (
      <div id="uc-question-section" className="uc-question-section">
        <QuestionGroupRenderer questions={this.state.questions} />
      </div>
    );
  }
});

module.exports = QuestionSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/QuestionSection.jsx